// @ts-nocheck
import { loadScript } from './utils';

// 按需引入百度地图
const mapLoader = () => {
  return new Promise((resolve) => {
    if (window?.BMap) {
      resolve(window?.BMap);
    }
    loadScript(
      '//api.map.baidu.com/api?v=2.0&ak=4DZaouyXaxOvyNAndmpWxnV4sBVFZXtI&callback=initBMap',
    );
    window.initBMap = () => {
      resolve(window?.BMap);
    };
  });
};

// 百度定位
function getGpsPosition() {
  return new Promise(function (resolve, reject) {
    mapLoader().then(() => {
      const geolocation = new BMap.Geolocation();
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(
        function (r) {
          console.log('gps position', r);
          console.log('百度地图：' + this.getStatus());
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            const lng = r.point.lng;
            const lat = r.point.lat;
            const point = new BMap.Point(lng, lat);

            // 根据定位获取所在城市
            const geoc = new BMap.Geocoder();
            geoc.getLocation(point, function (rs: any) {
              if (rs) {
                resolve(rs);
              } else {
                reject(new Error('解析位置信息失败'));
              }
            });
          } else {
            reject(new Error('城市定位失败'));
          }
        },
        { enableHighAccuracy: true },
      );
    });
  });
}

// 防抖
const debounce = (fn: any, wait: number, immediate?: boolean) => {
  let timer: NodeJS.Timeout | null = null;
  return function (...rest: any) {
    if (!timer && immediate) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fn.apply(this, rest);
    }
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fn.apply(this, rest);
    }, wait);
  };
};

export { getGpsPosition, debounce };
